/**
 * Safe, typed wrapper around localStorage.
 * Fails silently in environments where storage is unavailable (SSR, privacy mode).
 */

export function getItem<T>(key: string, fallback: T): T {
	try {
		const raw = window.localStorage.getItem(key);
		return raw === null ? fallback : (JSON.parse(raw) as T);
	} catch {
		return fallback;
	}
}

export function setItem(key: string, value: unknown): void {
	try {
		window.localStorage.setItem(key, JSON.stringify(value));
	} catch {
		// Storage full or unavailable — non-critical, ignore.
	}
}

export function removeItem(key: string): void {
	try {
		window.localStorage.removeItem(key);
	} catch {
		// Non-critical, ignore.
	}
}
